import { createContext, useContext } from "react";

import type { TimePickerContextValue } from "./TimePicker.types";
import { DEFAULT_MINUTE_STEP } from "./constants";

export function makeTimePickerContext({
  size = "md",
  layout = "default",
  minuteStep = DEFAULT_MINUTE_STEP,
  disabled = false,
  arrow = true,
  range = false,
  selected = null,
  selectedRange = [null, null],
  selectHour = () => {},
  selectMinute = () => {},
  pointerOffsetRef = { current: 0 },
  open = false,
  typing = null,
  openPopup = () => {},
  typeKey = () => false,
}: Partial<TimePickerContextValue>): Required<TimePickerContextValue> {
  return {
    size,
    layout,
    minuteStep,
    disabled,
    arrow,
    range,
    selected,
    selectedRange,
    selectHour,
    selectMinute,
    pointerOffsetRef,
    open,
    typing,
    openPopup,
    typeKey,
  };
}

export const TimePickerContext = createContext<
  Required<TimePickerContextValue>
>(makeTimePickerContext({}));

export function useTimePickerContext() {
  return useContext(TimePickerContext);
}
